export enum LimitSortMethod {
  Orders = 'Orders',
  TriggerPrice = 'Trigger Price',
  MarkPrice = 'Mark Price',
  Size = 'Size',
  Bonus = 'Bonus',
  Action = 'Action',
}
